import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {CountryService} from '../../../../domain/model/info/country/country.service';
import {OtherEducation} from '../../../../domain/model/education/other/other-education.model';
import {OtherEducationService} from '../../../../domain/model/education/other/other-education.service';
import {FileLocation, FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {Model} from '../../../../domain/model/common/model.class';
import {MonthPickerComponentModel} from '../../../../components/forms/controls/monthpicker/month-picker.component';
import {AddressModel} from '../../../../components/forms/controls/addresspicker/addresspicker.component';
import {AddressMapper} from '../../../../domain/model/common/mappers/address-mapper.class';
import {ActivatedRoute} from '@angular/router';
import {OtherEducationScreensManager} from './other-education-screens-manager.service';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;
import {VerificationService} from '../../../../components/verification/service/verification.service';

@Component({
    template: require('./other-education-screen.component.html')
})
export class OtherEducationScreenComponent {

    constructor(readonly educationService: OtherEducationService,
                countryService: CountryService,
                readonly route: ActivatedRoute,
                readonly screensManager: OtherEducationScreensManager,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {
        countryService.getCountriesProjection().subscribe(countries => this.countries = countries.map(c => c.name));
        countryService.getStates().subscribe(states => this.states = states.map(s => s.name));
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    private readonly _addressMapper = new AddressMapper();

    countries: Array<string> = [];
    states: Array<string> = [];
    phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    graduationDateMonthPickerModel = new MonthPickerComponentModel({
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(5, 'year')
    });
    attendanceDateConstrains = {
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(5, 'year')
    };
    attendanceFromMonthPickerModel = new MonthPickerComponentModel(this.attendanceDateConstrains);
    attendanceToMonthPickerModel = new MonthPickerComponentModel(this.attendanceDateConstrains);
    proofDocumentFileLocation: FileLocation;

    get index(): number {
        return this.route.snapshot.params['index'];
    }

    stepScreenModel = new StepScreenModel<OtherEducation>({
        initialDataModel: new OtherEducation(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            this.proofDocumentFileLocation = this.fileLocationFactory.create('otherEducation', `currentUser/${this.index}`, new ProjectionInformation('proofDocument'));
            this.verificationService.setUrl('otherEducation', undefined, `${this.index}`);
            return this.educationService.getCurrentUserModelEntry(this.index);
        },
        _submitDataFn: (model: OtherEducation) => {
            return this.educationService.updateCurrentUserModelEntry(this.index, model);
        },
        _hasYesNoQuestion: () => this.educationService.doesCurrentUserModelEntryExist(this.index).map(r => !r)
    });

    get model(): OtherEducation {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleAddressUpdated(addressModel: AddressModel) {
        this._addressMapper.update(this.model.address, addressModel);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/other/other-education-screen.component.ts